var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_accelerate"},[_c('Accelerate'),_c('AcclerateWays')],1)}
var staticRenderFns = []

export { render, staticRenderFns }